import { ReactNode, useEffect, useState } from "react";
import { LoadingTask } from "./models";
import { useLoading } from "./useLoading";

/**
 * Adds a loading task on load
 */
export const LoadingTaskWrapper = ({
  task,
  children,
}: {
  task: LoadingTask;
  children: ReactNode;
}) => {
  const [hasAddedTask, setHasAddedTask] = useState(false);
  const loadingManager = useLoading();

  useEffect(() => {
    loadingManager.addTask(task.meta, task.id);
    setHasAddedTask(true);
  }, [loadingManager, task]);

  if (!hasAddedTask) {
    return null;
  }

  return <>{children}</>;
};
